import { fetchConToken, fetchSinToken } from "../helpers/fetch";
import { armarParametrosRecetas } from "../helpers/parametros";

const RecetasDigitalesService = {
  getBuscardorMedicamentosTexto: (textoBuscado, liquidaciones, idTipoEmpadronamiento) => {
    return fetchConToken(`RecetasDigitales/traerMedicamentosPorTexto?textoBuscado=${textoBuscado}&liquidaciones=${liquidaciones}&idTipoEmpadronamiento=${idTipoEmpadronamiento}`);
  },
  getTiposRecetas: () => {
    return fetchConToken(`TipoRecetasDigitales`);
  },
  getSubtiposRecetas: () => {
    return fetchConToken(`SubtipoRecetasDigitales`);
  },
  getRecetasHistorialPrevio: (
    idAfiliado,
    idObraSocial
  ) => {
    return fetchConToken(
      `RecetasDigitales/traerHistorialRecetasPrevio?&idAfiliado=${idAfiliado}&idObraSocial=${idObraSocial}`
    );
  },
  getRecetasHistorial: (
    idAfiliado,
    idMedicamento,
    fechaDesde,
    fechaHasta,
    idEstadoReceta,
    idObraSocial
  ) => {
    return fetchConToken(
      `RecetasDigitales/traerHistorialRecetas?${armarParametrosRecetas(
        idAfiliado,
        idMedicamento,
        fechaDesde,
        fechaHasta,
        idEstadoReceta,
        idObraSocial
      )}`
    );
  },
  getContadoresRecetasHistorial: (idAfiliado,
    idMedicamento,
    fechaDesde,
    fechaHasta,
    idEstadoReceta,
    idObraSocial) => {
    return fetchConToken(
      `RecetasDigitales/traerContadoresHistorialRecetas?${armarParametrosRecetas(
        idAfiliado,
        idMedicamento,
        fechaDesde,
        fechaHasta,
        idEstadoReceta,
        idObraSocial
      )}`
    );
  },
  postReceta: (data) => {
    return fetchConToken(`RecetasDigitales`, data, "POST");
  },
  postRepetirReceta: (data) => {
    return fetchConToken(`RecetasDigitales/repetirReceta`, data, "POST");
  },
  putReceta: (data) => {
    return fetchConToken(`RecetasDigitales`, data, "PUT");
  },
  postMedicamentos: (medicamentos) => {
    return fetchConToken(`RecetasDigitalesMedicamentos`, medicamentos, "POST");
  },
  putFinalizadaReceta: (data) => {
    return fetchConToken(`RecetasDigitales/modificarFinalizada`, data, "PUT");
  },
  imprimirReceta: (idRecetaDigital) => {
    return fetchConToken(`RecetasDigitales/generarPDF/${idRecetaDigital}`);
  },
  enviarReceta: (idRecetaDigital) => {
    return fetchConToken(`RecetasDigitales/generarMail/${idRecetaDigital}`);
  },
  anularReceta: (data) => {
    return fetchConToken(`RecetasDigitales/anularReceta/`, data, "PUT");
  },
  getData: (idRecetaDigital) => {
    return fetchSinToken(`RecetasDigitales/TraerDatosReceta/${idRecetaDigital}`)
  },
  getEspecialidadesPublic: (idRecetaDigital) => {
    return fetchSinToken(`RecetasDigitales/Contratos`)
  },
  getProvinciasCSF: () => {
    return fetchConToken(`RecetasDigitales/traerProvinciasCSF`);
  },
};

export default RecetasDigitalesService;
